import React from "react";
import { Offcanvas } from "react-bootstrap";
import closeIcon from "include/images/dark-close-icon.svg";
import emptyIcon from "include/images/nrf.svg";

const EnemyImagesFlyer = ({ showModal, toggleModal, images, enemyName }) => {
  return (
    <Offcanvas
      className={"offcanvas offcanvas-end custom-offcanvas-pannel "}
      show={showModal}
      onHide={toggleModal}
      id="rewardPannel"
      placement="right"
      name="rewardPannel"
      backdrop={true}
    >
      <Offcanvas.Header className="offCanvas-header">
        <div>
          <h5 className="text-capitalize">{enemyName} Images</h5>
        </div>
        <div className="btn_close pointer" data-bs-dismiss="offcanvas" aria-label="Close" onClick={toggleModal}>
          <img src={closeIcon} alt="" />
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="fwc-body">
          <div className="table-responsive">
            {images?.length === 0 ? (
              <div className="fwc-body">
                <div className="no-record-found-container">
                  <div className="nfr-box">
                    <img src={emptyIcon} alt="No Record Found" />
                    <div className="nrf-text">
                      <h5>No Records Found!</h5>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table large-table">
                  <thead>
                    <tr>
                      <th>Count</th>
                      <th>Image</th>
                    </tr>
                  </thead>
                  <tbody>
                    {images?.map((image, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <div style={{ width: 60 }}>
                            {image && (
                              <img src={process.env.REACT_APP_CDN + "telegramBattleGame/image/enemy/" + image} alt="" />
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EnemyImagesFlyer;
